import { useMutation, useQuery } from '@tanstack/react-query';

import { downloadClientIirs, getProblemClientsStatistic, getReport, getUnbindReport } from '../../../../api';
import { Criteria, SortType } from '../../../../types/pagination';

export const useClientReport = (agreementId: string | undefined, isUnsubscribeClient = false) => {
  return useMutation({
    mutationKey: ['getReport', agreementId, isUnsubscribeClient],
    mutationFn: () => (isUnsubscribeClient ? getUnbindReport(agreementId) : getReport(agreementId)),
  });
};

export const useClientProblem = (agreement: string | undefined) => {
  return useQuery({
    queryKey: ['getClientProblem', agreement],
    queryFn: () =>
      getProblemClientsStatistic({
        pageNumber: 0,
        pageSize: 1,
        sortFieldName: 'number',
        sortDirection: SortType.Ask,
        filters: [
          {
            fieldName: 'number',
            filterCriteria: Criteria.Equals,
            matches: [agreement!],
          },
        ],
      }),
    enabled: !!agreement,
  });
};

export const useClientIirExport = () => {
  return useMutation({
    mutationKey: ['downloadClientIirs'],
    mutationFn: (params: { agreementId: string; dateFrom: string; dateTo: string }) => downloadClientIirs(params),
  });
};
